
import { Vue, Component, Prop } from 'vue-property-decorator'
import DashboardStudent from '../../components/Dashboards/DashboardStudent.vue'
  @Component({
    name: 'student',
    components: { DashboardStudent }
  })
export default class student extends Vue {
  mounted() {}
}
